import { Consent } from '@/routes/shared/consent';

export function OnboardingConsent() {
  return <Consent buttonText="Continue" headerText="Does your website have a consent banner?" />;
}
